export const toFirstLetterUppercase = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);
